export default "__VITE_ASSET__KypM6Vjk__"